function gz_custom_decompress(gzCustomModule, uint8Array) {
    var statusOrBytesCount = 0;

    const gzread_in_memory2 = gzCustomModule.cwrap(
        'gzread_in_memory2', // name of C function
        'number', // return type
        ['array', 'number']
    );

    const gz_custom_outstring = gzCustomModule.cwrap(
        'gz_custom_outstring', // name of C function
        'string', // return type
        []
    );

    const gz_custom_error = gzCustomModule.cwrap(
        'gz_custom_error', // name of C function
        'number', // return type
        []
    );

    const gz_custom_free_all = gzCustomModule.cwrap(
        'gz_custom_free_all', // name of C function
        'number', // return type
        []
    );

    console.log('Going to call gzread_in_memory2');
    statusOrBytesCount = gzread_in_memory2(uint8Array, uint8Array.length);
    console.log('statusOrBytesCount', statusOrBytesCount);

    if (statusOrBytesCount > 0) {
        const resultStringRaw = gz_custom_outstring();
        console.log(`resultStringRaw.length: ${resultStringRaw.length}`);
        // console.log(`resultStringRaw: ${resultStringRaw}`);
        const resultString = `${resultStringRaw}`; // Make a copy.
        gz_custom_free_all();
        return resultString;
    } else {
        const error = gz_custom_error();
        console.error(`gz_custom_error: ${error}`);
        return null;
    }
}

if (typeof exports !== 'undefined') {
    exports.gz_custom_decompress = gz_custom_decompress;
}
